import axios from "axios";
import * as Constants from "../../../constants/Constants";

export function deleteUserCardDetail(card) {
    return new Promise(async (resolve, reject) => {
        let payload = card;
        let token = localStorage.getItem("token");
        let tenant = localStorage.getItem("tenant");
        axios.defaults.timeout = Constants.AXIOS_DEFAULT_TIMEOUT;
        axios
            .post(
                `${process.env.REACT_APP_ACCESS_KEY}/${tenant}${Constants.DELETE_USER_CARD_DETAIL_API_ROUTE}`,
                payload,
                {
                    headers: {
                        "Content-Type": Constants.CONTANT_TYPE,
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
